(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)')

    const init = () => {
      document.querySelectorAll('[data-blog-slider-section]').forEach((section) => {
        const slider = section.querySelector('[data-blog-slider]')
        if (!slider || typeof window.Swiper === 'undefined') return

        if (slider.swiper) slider.swiper.destroy(true, true)

        const prevEl = section.querySelector('[data-blog-nav-prev]')
        const nextEl = section.querySelector('[data-blog-nav-next]')
        const desktopItems = parseInt(section.dataset.desktopItems, 10) || 3

        if (mobileQuery.matches) {
          const refEl = section.querySelector('.blog-slider__ref')
          const slidesOffsetBefore = refEl
            ? Math.max(0, Math.round(refEl.getBoundingClientRect().left))
            : 16

          new window.Swiper(slider, {
            slidesPerView: 1.25,
            spaceBetween: 16,
            slidesOffsetBefore,
            watchOverflow: true,
            navigation: { prevEl, nextEl },
          })
        } else {
          new window.Swiper(slider, {
            slidesPerView: desktopItems,
            spaceBetween: 24,
            watchOverflow: true,
            navigation: { prevEl, nextEl },
          })
        }
      })
    }

    document.addEventListener('DOMContentLoaded', init)
    mobileQuery.addEventListener('change', init)

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector('[data-blog-slider-section]')) init()
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-blogs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)')

    const init = () => {
      document.querySelectorAll('[data-em-blogs-section]').forEach((section) => {
        const slider = section.querySelector('[data-em-blogs]')
        if (!slider || typeof window.Swiper === 'undefined') return

        if (slider.swiper) slider.swiper.destroy(true, true)

        const prevEl = section.querySelector('[data-em-blogs-nav-prev]')
        const nextEl = section.querySelector('[data-em-blogs-nav-next]')

        if (mobileQuery.matches) {
          const refEl = section.querySelector('.em-blogs__ref')
          const slidesOffsetBefore = refEl
            ? Math.max(0, Math.round(refEl.getBoundingClientRect().left))
            : 16

          new window.Swiper(slider, {
            slidesPerView: 1.25,
            spaceBetween: 16,
            slidesOffsetBefore,
            watchOverflow: true,
            navigation: { prevEl, nextEl },
          })
        } else {
          new window.Swiper(slider, {
            slidesPerView: 4,
            spaceBetween: 24,
            watchOverflow: true,
            navigation: { prevEl, nextEl },
          })
        }
      })
    }

    document.addEventListener('DOMContentLoaded', init)
    mobileQuery.addEventListener('change', init)

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector('[data-em-blogs-section]')) init()
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-catalog-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 768px)')

    const bindLinks = (root) => {
      if (root.dataset.emCatalogCategoriesBound) return
      root.addEventListener('click', (event) => {
        if (event.target.closest('.em-catalog-categories__nav')) return
        const card = event.target.closest('[data-em-catalog-category-link]')
        if (!card) return
        window.location.href = card.dataset.emCatalogCategoryLink
      })
      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return
        const card = event.target.closest('[data-em-catalog-category-link]')
        if (!card) return
        event.preventDefault()
        window.location.href = card.dataset.emCatalogCategoryLink
      })
      root.dataset.emCatalogCategoriesBound = 'true'
    }

    const init = () => {
      document.querySelectorAll('[data-em-catalog-categories-root]').forEach((root) => {
        const slider = root.querySelector('[data-em-catalog-categories-slider]')
        if (!slider) return

        bindLinks(root)

        const count = parseInt(root.dataset.collectionCount) || 0
        const useSlider = count > 4

        if (slider.swiper) slider.swiper.destroy(true, true)

        root.classList.toggle('em-catalog-categories__row--slider', useSlider)
        root.classList.toggle('em-catalog-categories__row--grid', !useSlider)

        if (!useSlider || !desktopQuery.matches) return

        if (typeof window.Swiper === 'undefined') return

        const prev = root.querySelector('[data-em-catalog-categories-prev]')
        const next = root.querySelector('[data-em-catalog-categories-next]')

        const options = {
          slidesPerView: 4,
          spaceBetween: 24,
          watchOverflow: true,
        }

        if (prev && next) {
          options.navigation = {
            prevEl: prev,
            nextEl: next,
            disabledClass: 'swiper-button-disabled',
          }
        }

        new window.Swiper(slider, options)
      })
    }

    document.addEventListener('DOMContentLoaded', init)
    window.addEventListener('load', init)
    desktopQuery.addEventListener('change', init)
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && event.target.querySelector('[data-em-catalog-categories-root]')) init()
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-header-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (root) => {
      if (!root || root.dataset.hcBound) return;
      root.dataset.hcBound = 'true';

      /* Breadcrumb expand/collapse toggle (mobile). */
      root.querySelectorAll('.em-header-collection__breadcrumb-toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const nav = toggle.closest('.em-header-collection__breadcrumb');
          const open = nav.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      /* "Terug" uses browser history when there is a same-origin referrer. */
      root.querySelectorAll('[data-em-back]').forEach((link) => {
        link.addEventListener('click', (event) => {
          try {
            if (document.referrer && new URL(document.referrer).origin === window.location.origin) {
              event.preventDefault();
              window.history.back();
            }
          } catch (e) {
            /* fall back to the href */
          }
        });
      });

      /* Subcollection slider links. */
      const sliderRoot = root.querySelector('[data-hc-root]');
      if (sliderRoot && !sliderRoot.dataset.hcLinksBound) {
        sliderRoot.dataset.hcLinksBound = 'true';
        sliderRoot.addEventListener('click', (event) => {
          if (event.target.closest('.em-header-collection__nav')) return;
          const slide = event.target.closest('[data-hc-link]');
          if (slide) window.location.href = slide.dataset.hcLink;
        });
        sliderRoot.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          const slide = event.target.closest('[data-hc-link]');
          if (!slide) return;
          event.preventDefault();
          window.location.href = slide.dataset.hcLink;
        });
      }
    };

    const updateNavTop = (root) => {
      const imageWrap = root.querySelector('.em-header-collection__image-wrap');
      if (!imageWrap) return;
      const imageRect = imageWrap.getBoundingClientRect();
      const rootRect = root.getBoundingClientRect();
      root.style.setProperty('--hc-nav-top', imageRect.top - rootRect.top + imageRect.height / 2 + 'px');
    };

    /* Mobile shows a static 2-column grid (CSS); Swiper only runs from 750px up. */
    const desktopMq = window.matchMedia('(min-width: 750px)');

    const initSliders = () => {
      document.querySelectorAll('.em-header-collection [data-hc-root]').forEach((sliderRoot) => {
        const slider = sliderRoot.querySelector('[data-hc-slider]');
        if (!slider || typeof window.Swiper === 'undefined') return;

        if (!desktopMq.matches) {
          if (slider.swiper) slider.swiper.destroy(true, true);
          return;
        }

        if (slider.swiper) slider.swiper.destroy(true, true);

        const prev = sliderRoot.querySelector('[data-hc-prev]');
        const next = sliderRoot.querySelector('[data-hc-next]');

        const options = {
          slidesPerView: 4,
          spaceBetween: 24,
          watchOverflow: true,
          breakpoints: {
            1200: { slidesPerView: 5, spaceBetween: 24 },
          },
        };

        if (prev && next) {
          options.navigation = { prevEl: prev, nextEl: next };
        }

        new window.Swiper(slider, options);
        updateNavTop(sliderRoot);
      });
    };

    desktopMq.addEventListener('change', () => whenSwiperReady(initSliders));

    /* The Swiper bundle is loaded with `defer`, and Shopify's combined section
       JS can run before it finishes. Wait for window.Swiper before initialising. */
    const whenSwiperReady = (cb, tries) => {
      tries = tries || 0;
      if (typeof window.Swiper !== 'undefined') {
        cb();
      } else if (tries < 100) {
        setTimeout(() => whenSwiperReady(cb, tries + 1), 50);
      }
    };

    const init = () => {
      document.querySelectorAll('.em-header-collection').forEach(initSection);
      if (document.querySelector('.em-header-collection [data-hc-root]')) {
        whenSwiperReady(initSliders);
      }
    };

    window.addEventListener('resize', () => {
      document.querySelectorAll('.em-header-collection [data-hc-root]').forEach(updateNavTop);
    });

    /* Tooltip popup open/close (bound once at document level). */
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-formats-popup]');
      if (trigger) {
        const popup = document.getElementById('em-hc-popup-' + trigger.dataset.formatsPopup);
        if (popup) popup.showModal();
        return;
      }

      const closeBtn = e.target.closest('.em-hc-popup__close');
      if (closeBtn) {
        closeBtn.closest('.em-hc-popup')?.close();
        return;
      }

      if (e.target.classList.contains('em-hc-popup')) {
        e.target.close();
      }
    });

    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && typeof event.target.querySelector === 'function' && event.target.querySelector('.em-header-collection')) {
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-header-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DAY_MAP = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

    const toMinutes = (value) => {
      if (!value) return null;
      const match = value.match(/^(\d{1,2}):(\d{2})$/);
      if (!match) return null;
      return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
    };

    const update = (el) => {
      const tz = el.dataset.timezone || 'Europe/Amsterdam';
      const days = (el.dataset.days || '')
        .split(',')
        .map((s) => parseInt(s.trim(), 10))
        .filter((n) => !Number.isNaN(n));
      const open = toMinutes(el.dataset.openTime);
      const close = toMinutes(el.dataset.closeTime);

      let parts;
      try {
        parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }).formatToParts(new Date());
      } catch (e) {
        parts = new Intl.DateTimeFormat('en-US', {
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }).formatToParts(new Date());
      }

      const get = (type) => {
        const found = parts.find((p) => p.type === type);
        return found ? found.value : '';
      };

      const weekday = DAY_MAP[get('weekday')];
      let hour = parseInt(get('hour'), 10);
      if (hour === 24) hour = 0;
      const minute = parseInt(get('minute'), 10);
      const now = hour * 60 + minute;

      const isOpen =
        days.indexOf(weekday) !== -1 && open !== null && close !== null && now >= open && now < close;

      el.classList.toggle('is-open', isOpen);
      el.classList.toggle('is-closed', !isOpen);

      const label = el.querySelector('[data-availability-label]');
      if (label) {
        label.textContent = isOpen ? el.dataset.labelOpen || '' : el.dataset.labelClosed || '';
      }
    };

    const initAll = (root) => {
      (root || document).querySelectorAll('[data-availability]').forEach(update);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DAY_MAP = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

    const toMinutes = (value) => {
      if (!value) return null;
      const match = value.match(/^(\d{1,2}):(\d{2})$/);
      if (!match) return null;
      return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
    };

    const update = (el) => {
      const tz = el.dataset.timezone || 'Europe/Amsterdam';
      const days = (el.dataset.days || '')
        .split(',')
        .map((s) => parseInt(s.trim(), 10))
        .filter((n) => !Number.isNaN(n));
      const open = toMinutes(el.dataset.openTime);
      const close = toMinutes(el.dataset.closeTime);

      let parts;
      try {
        parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }).formatToParts(new Date());
      } catch (e) {
        parts = new Intl.DateTimeFormat('en-US', {
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }).formatToParts(new Date());
      }

      const get = (type) => {
        const found = parts.find((p) => p.type === type);
        return found ? found.value : '';
      };

      const weekday = DAY_MAP[get('weekday')];
      let hour = parseInt(get('hour'), 10);
      if (hour === 24) hour = 0;
      const minute = parseInt(get('minute'), 10);
      const now = hour * 60 + minute;

      const isOpen =
        days.indexOf(weekday) !== -1 && open !== null && close !== null && now >= open && now < close;

      el.classList.toggle('is-open', isOpen);
      el.classList.toggle('is-closed', !isOpen);

      const label = el.querySelector('[data-availability-label]');
      if (label) {
        label.textContent = isOpen ? el.dataset.labelOpen || '' : el.dataset.labelClosed || '';
      }
    };

    const initAll = (root) => {
      (root || document).querySelectorAll('[data-availability]').forEach(update);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const sync = (root) => {
      (root || document).querySelectorAll('[data-usp-slider]').forEach((slider) => {
        if (typeof window.Swiper === 'undefined') return;

        if (mobileQuery.matches) {
          if (!slider.swiper) {
            new window.Swiper(slider, {
              slidesPerView: 1.5,
              spaceBetween: 16,
              freeMode: { enabled: true },
              watchOverflow: true,
            });
          }
        } else if (slider.swiper) {
          slider.swiper.destroy(true, true);
        }
      });
    };

    // Swiper is loaded with `defer`, so it may not be ready yet when this
    // bundle first runs. Wait for the DOM, then fall back to window load if
    // the library still hasn't executed.
    const ready = (root) => {
      if (typeof window.Swiper === 'undefined') {
        window.addEventListener('load', () => sync(root), { once: true });
      } else {
        sync(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => ready());
    } else {
      ready();
    }

    mobileQuery.addEventListener('change', () => sync());
    document.addEventListener('shopify:section:load', (event) => ready(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-related-articles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)')

    const init = () => {
      document.querySelectorAll('[data-em-related-articles-section]').forEach((section) => {
        const slider = section.querySelector('[data-em-related-articles]')
        if (!slider || typeof window.Swiper === 'undefined') return

        if (slider.swiper) slider.swiper.destroy(true, true)

        const prevEl = section.querySelector('[data-em-related-articles-nav-prev]')
        const nextEl = section.querySelector('[data-em-related-articles-nav-next]')

        if (mobileQuery.matches) {
          new window.Swiper(slider, {
            slidesPerView: 0.8,
            spaceBetween: 16,
            watchOverflow: true,
            navigation: { prevEl, nextEl, lockClass: 'swiper-button-lock' },
          })
        } else {
          new window.Swiper(slider, {
            slidesPerView: 2,
            spaceBetween: 24,
            watchOverflow: true,
            navigation: { prevEl, nextEl, lockClass: 'swiper-button-lock' },
          })
        }
      })
    }

    document.addEventListener('DOMContentLoaded', init)
    mobileQuery.addEventListener('change', init)

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector('[data-em-related-articles-section]')) init()
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-team"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)')

    const positionNav = (section) => {
      const slide = section.querySelector('.em-team__image-wrap')
      const navs = section.querySelectorAll('.em-team__nav')
      if (!slide || !navs.length) return
      const center = Math.round(slide.getBoundingClientRect().height / 2 - 19)
      navs.forEach((nav) => {
        nav.style.top = center + 'px'
      })
    }

    const init = () => {
      document.querySelectorAll('[data-em-team-section]').forEach((section) => {
        const slider = section.querySelector('[data-em-team]')
        if (!slider || typeof window.Swiper === 'undefined') return

        if (slider.swiper) slider.swiper.destroy(true, true)

        const prevEl = section.querySelector('[data-em-team-nav-prev]')
        const nextEl = section.querySelector('[data-em-team-nav-next]')

        if (mobileQuery.matches) {
          const refEl = section.querySelector('.em-team__ref')
          const slidesOffsetBefore = refEl
            ? Math.max(0, Math.round(refEl.getBoundingClientRect().left))
            : 16

          new window.Swiper(slider, {
            slidesPerView: 1.25,
            spaceBetween: 16,
            slidesOffsetBefore,
            slidesOffsetAfter: slidesOffsetBefore,
            watchOverflow: true,
            navigation: { prevEl, nextEl },
            on: { init: () => positionNav(section), resize: () => positionNav(section) },
          })
        } else {
          new window.Swiper(slider, {
            slidesPerView: 5,
            spaceBetween: 22,
            watchOverflow: true,
            navigation: { prevEl, nextEl },
            on: { init: () => positionNav(section), resize: () => positionNav(section) },
          })
        }

        positionNav(section)
      })
    }

    document.addEventListener('DOMContentLoaded', init)
    mobileQuery.addEventListener('change', init)
    window.addEventListener('resize', () => {
      document.querySelectorAll('[data-em-team-section]').forEach(positionNav)
    })

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector('[data-em-team-section]')) init()
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Swap the still for the real player only once the visitor asks for it, so three
    // embeds on one page cost nothing until they are actually watched.
    const play = (facade) => {
      const embedUrl = facade.dataset.embedUrl
      if (!embedUrl) return

      const separator = embedUrl.indexOf('?') === -1 ? '?' : '&'
      const iframe = document.createElement('iframe')
      iframe.className = 'em-video-testimonials__iframe'
      iframe.src = embedUrl + separator + 'autoplay=1'
      iframe.title = facade.getAttribute('aria-label') || ''
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      iframe.allowFullscreen = true

      facade.replaceWith(iframe)
      iframe.focus()
    }

    // Uploaded files keep their video element; only the overlay comes and goes, so the
    // visitor can always pause and pick up again.
    const bindNativePlayers = (root) => {
      root.querySelectorAll('[data-em-video-testimonial-native]').forEach((wrapper) => {
        if (wrapper.dataset.bound === 'true') return
        wrapper.dataset.bound = 'true'

        const video = wrapper.querySelector('video')
        const overlay = wrapper.querySelector('[data-em-video-testimonial-play]')
        if (!video || !overlay) return

        const toggle = () => {
          if (video.paused) {
            video.play()
          } else {
            video.pause()
          }
        }

        overlay.addEventListener('click', toggle)
        video.addEventListener('click', toggle)
        video.addEventListener('play', () => {
          overlay.hidden = true
        })
        video.addEventListener('pause', () => {
          overlay.hidden = false
        })
        video.addEventListener('ended', () => {
          overlay.hidden = false
        })
      })
    }

    // A missing maxresdefault still loads: YouTube answers with a 120x90 grey placeholder
    // instead of an error, so the width is what gives it away.
    const swapPlaceholderPoster = (image) => {
      const fallback = image.dataset.fallbackSrc
      if (!fallback || !image.naturalWidth || image.naturalWidth > 120) return
      image.dataset.fallbackSrc = ''
      image.src = fallback
    }

    const checkPosters = (root) => {
      root.querySelectorAll('.em-video-testimonials__poster[data-fallback-src]').forEach((image) => {
        if (image.complete) {
          swapPlaceholderPoster(image)
        } else {
          image.addEventListener('load', () => swapPlaceholderPoster(image), { once: true })
        }
      })
    }

    // Below 750px the videos become a swipeable slider; above it the CSS grid takes over,
    // so Swiper is torn down rather than reconfigured.
    const mobileQuery = window.matchMedia('(max-width: 749px)')

    const initSliders = () => {
      document.querySelectorAll('[data-em-video-testimonials-root]').forEach((root) => {
        const slider = root.querySelector('[data-em-video-testimonials-slider]')
        if (!slider || typeof window.Swiper === 'undefined') return

        if (slider.swiper) slider.swiper.destroy(true, true)
        if (!mobileQuery.matches) return

        const reference = root.querySelector('.em-video-testimonials__ref')
        const offset = reference ? Math.max(0, Math.round(reference.getBoundingClientRect().left)) : 16
        const perView = Number(root.dataset.slidesMobile) || 1
        const pagination = root.querySelector('[data-em-video-testimonials-pagination]')

        const options = {
          // The fraction lets the next video peek, which is what signals the slider is swipeable.
          slidesPerView: perView + 0.15,
          spaceBetween: 16,
          slidesOffsetBefore: offset,
          slidesOffsetAfter: offset,
          watchOverflow: true,
        }

        if (pagination) {
          options.pagination = { el: pagination, clickable: true }
        }

        new window.Swiper(slider, options)
      })
    }

    document.addEventListener('click', (event) => {
      const target = event.target
      if (!(target instanceof Element)) return
      const facade = target.closest('[data-em-video-testimonial]')
      if (facade) play(facade)
    })

    document.addEventListener('DOMContentLoaded', () => {
      checkPosters(document)
      bindNativePlayers(document)
      initSliders()
    })

    mobileQuery.addEventListener('change', initSliders)

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target || typeof event.target.querySelector !== 'function') return
      checkPosters(event.target)
      bindNativePlayers(event.target)
      if (event.target.querySelector('[data-em-video-testimonials-root]')) initSliders()
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    const closeItem = (item) => {
      if (!item.open || item.classList.contains('faq__item--closing')) return

      if (reducedMotionQuery.matches) {
        item.open = false
        return
      }

      const panel = item.querySelector('.faq__panel')
      if (!panel) {
        item.open = false
        return
      }

      item.classList.add('faq__item--closing')

      let finished = false
      const finish = (event) => {
        if (event && event.propertyName !== 'grid-template-rows') return
        if (finished) return
        finished = true
        panel.removeEventListener('transitionend', finish)
        clearTimeout(fallback)
        item.open = false
        item.classList.remove('faq__item--closing')
      }

      const fallback = setTimeout(finish, 350)
      panel.addEventListener('transitionend', finish)
    }

    const initFaq = (root) => {
      const items = Array.from(root.querySelectorAll('.faq__item'))

      items.forEach((item) => {
        if (item.dataset.faqBound === 'true') return
        item.dataset.faqBound = 'true'

        const summary = item.querySelector('summary')
        if (!summary) return

        summary.addEventListener('click', (event) => {
          event.preventDefault()

          if (item.open) {
            closeItem(item)
            return
          }

          items.forEach((other) => {
            if (other !== item) closeItem(other)
          })

          item.open = true
        })
      })
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-faq-root]').forEach(initFaq)
    })

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target?.querySelector?.('[data-faq-root]')
      if (root) initFaq(root)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFeaturedCollectionSwiper = () => {
      document.querySelectorAll('[data-featured-collection-root]').forEach((root) => {
        const slider = root.querySelector('[data-featured-collection-slider]')
        if (!slider) return

        if (typeof window.Swiper === 'undefined') return

        if (slider.swiper) slider.swiper.destroy(true, true)

        const columnsDesktop = parseInt(root.dataset.columnsDesktop) || 4
        const prev = root.querySelector('[data-featured-collection-prev]')
        const next = root.querySelector('[data-featured-collection-next]')

        const options = {
          slidesPerView: 1.25,
          spaceBetween: 16,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
          watchOverflow: true,
          breakpoints: {
            768: {
              slidesPerView: columnsDesktop,
              spaceBetween: 24,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
          },
        }

        if (prev && next) {
          options.navigation = {
            prevEl: prev,
            nextEl: next,
            disabledClass: 'swiper-button-disabled',
          }
        }

        new window.Swiper(slider, options)
      })
    }

    document.addEventListener('DOMContentLoaded', initFeaturedCollectionSwiper)
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && event.target.querySelector('[data-featured-collection-root]')) {
        initFeaturedCollectionSwiper()
      }
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function updateHeaderHeightVar() {
    const header = document.querySelector('.section-header') || document.getElementById('header');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }

  function toggleHeaderStickyClass() {
    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;

    sectionHeader.classList.toggle('header-sticky', window.scrollY > 34);
  }

  function initHeaderUspSwiper() {
    if (!window.Swiper) return;

    const sliders = document.querySelectorAll('.header-usp-swiper');
    sliders.forEach((slider) => {
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }

      new window.Swiper(slider, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1500,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        breakpoints: {
          481: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 'auto',
          },
        },
      });
    });
  }

  function initDesktopMegaMenu() {
    const navRoot = document.getElementById('rotim-desktop-nav');
    const trigger = document.getElementById('rotim-mega-trigger');
    const mega = document.getElementById('rotim-mega-menu');
    const overlay = document.getElementById('rotim-mega-overlay');
    if (!navRoot || !trigger || !mega) return;

    const categoryButtons = mega.querySelectorAll('[data-mega-cat]');
    const panels = mega.querySelectorAll('[data-mega-panel]');
    const rightColumn = mega.querySelector('.rotim-mega-menu__right');

    const getActiveIndex = () => {
      const activeBtn = mega.querySelector('[data-mega-cat].is-active');
      return activeBtn?.dataset.megaCat || '0';
    };

    const syncRightWidth = (index = getActiveIndex(), immediate = false) => {
      if (!rightColumn) return;
      const panel = mega.querySelector(`#rotim-mega-panel-${index}`) || mega.querySelector('[data-mega-panel].is-active');
      if (!panel) return;
      const leftColumn = mega.querySelector('.rotim-mega-menu__left');

      const styles = window.getComputedStyle(rightColumn);
      const padLeft = parseFloat(styles.paddingLeft || '0');
      const padRight = parseFloat(styles.paddingRight || '0');
      const desiredWidth = Math.ceil(panel.scrollWidth + padLeft + padRight);
      const megaLeft = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rotim-mega-left') || '0');
      const leftWidth = leftColumn ? leftColumn.getBoundingClientRect().width : 0;
      const viewportPadding = 24;
      const maxAvailableWidth = Math.max(300, Math.floor(window.innerWidth - megaLeft - leftWidth - viewportPadding));
      const targetWidth = Math.max(300, Math.min(desiredWidth, maxAvailableWidth));

      if (immediate) {
        const prevTransition = rightColumn.style.transition;
        rightColumn.style.transition = 'none';
        rightColumn.style.width = `${targetWidth}px`;
        rightColumn.offsetHeight;
        rightColumn.style.transition = prevTransition;
        return;
      }

      rightColumn.style.width = `${targetWidth}px`;
    };

    const syncMegaPosition = () => {
      const boundsTarget = navRoot.querySelector('.page-width') || navRoot;
      const rect = boundsTarget.getBoundingClientRect();
      const styles = window.getComputedStyle(boundsTarget);
      const padLeft = parseFloat(styles.paddingLeft || '0');
      const padRight = parseFloat(styles.paddingRight || '0');
      const navRect = navRoot.getBoundingClientRect();
      const top = Math.max(0, Math.round(navRect.bottom));
      const left = Math.max(0, Math.round(rect.left + padLeft));
      mega.style.top = `${top}px`;
      mega.style.left = `${left}px`;
      document.documentElement.style.setProperty('--rotim-mega-top', `${top}px`);
      document.documentElement.style.setProperty('--rotim-mega-left', `${left}px`);
    };

    const setOpen = (open) => {
      if (open) {
        document.querySelectorAll('[data-nav-dropdown].is-open').forEach((dd) => {
          dd.classList.remove('is-open');
          dd.setAttribute('aria-hidden', 'true');
        });
      }
      syncMegaPosition();
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      mega.classList.toggle('is-open', open);
      if (open) syncRightWidth(getActiveIndex(), true);
      if (overlay) overlay.classList.toggle('is-open', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
      document.body.style.overflow = open ? 'hidden' : '';
    };

    const activatePanel = (index) => {
      categoryButtons.forEach((btn) => {
        const active = btn.dataset.megaCat === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const active = panel.id === `rotim-mega-panel-${index}`;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      syncRightWidth(index);
    };

    if (categoryButtons.length) {
      activatePanel(categoryButtons[0].dataset.megaCat || '0');
      categoryButtons.forEach((btn) => {
        const handler = () => activatePanel(btn.dataset.megaCat || '0');
        btn.addEventListener('mouseenter', handler);
        btn.addEventListener('focus', handler);
        btn.addEventListener('click', handler);
      });
    }

    trigger.addEventListener('click', () => {
      const open = trigger.getAttribute('aria-expanded') !== 'true';
      setOpen(open);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });

    document.addEventListener('click', (event) => {
      if (!navRoot.contains(event.target)) setOpen(false);
    });

    window.addEventListener('resize', syncMegaPosition, { passive: true });
    window.addEventListener('scroll', syncMegaPosition, { passive: true });
    syncMegaPosition();
    syncRightWidth(getActiveIndex(), true);
  }

  function initNavDropdowns() {
    const navRoot = document.getElementById('rotim-desktop-nav');
    if (!navRoot) return;

    const navItems = navRoot.querySelectorAll('[data-nav-item]');
    const dropdowns = navRoot.querySelectorAll('[data-nav-dropdown]');
    let closeTimer = null;

    const getNavBottom = () => {
      const rect = navRoot.getBoundingClientRect();
      return Math.round(rect.bottom);
    };

    const getPageLeft = () => {
      const target = navRoot.querySelector('.page-width') || navRoot;
      const rect = target.getBoundingClientRect();
      const styles = window.getComputedStyle(target);
      return Math.round(rect.left + parseFloat(styles.paddingLeft || '0'));
    };

    const navOverlay = document.getElementById('rotim-nav-overlay');

    const hideAll = () => {
      dropdowns.forEach((dd) => {
        dd.classList.remove('is-open');
        dd.setAttribute('aria-hidden', 'true');
      });
      if (navOverlay) navOverlay.classList.remove('is-open');
    };

    const positionAndShow = (dropdown, triggerItem) => {
      const top = getNavBottom();
      const left = triggerItem
        ? Math.round(triggerItem.getBoundingClientRect().left) - 16
        : getPageLeft();
      document.documentElement.style.setProperty('--rotim-nav-bottom', `${top}px`);
      dropdown.style.top = `${top}px`;
      dropdown.style.left = `${left}px`;
      dropdown._triggerItem = triggerItem || null;
      dropdown.classList.add('is-open');
      dropdown.setAttribute('aria-hidden', 'false');
      if (navOverlay) navOverlay.classList.add('is-open');
    };

    const activateL2 = (dropdown, childIdx) => {
      dropdown.querySelectorAll('[data-l2-item]').forEach((item) => {
        item.classList.toggle('is-active', item.dataset.l2Item === String(childIdx));
      });
      dropdown.querySelectorAll('[data-l3-panel]').forEach((panel) => {
        const match = panel.dataset.l3Panel === String(childIdx);
        panel.hidden = !match;
        if (match) {
          // Open l3 in the column right of the hovered l2 item's column (10 items per column).
          const col = Math.floor(Number(childIdx) / 10);
          panel.style.setProperty('--l3-col', col + 1);
        }
      });
      dropdown.querySelectorAll('[data-l4-panel]').forEach((panel) => {
        panel.hidden = true;
      });
      dropdown.querySelectorAll('[data-l3-item]').forEach((item) => {
        item.classList.remove('is-active');
      });
      dropdown.querySelectorAll('[data-l4-panel]').forEach((panel) => {
        panel.hidden = true;
      });
    };

    const activateL3 = (dropdown, itemKey) => {
      dropdown.querySelectorAll('[data-l3-item]').forEach((item) => {
        item.classList.toggle('is-active', item.dataset.l3Item === itemKey);
      });
      dropdown.querySelectorAll('[data-l4-panel]').forEach((panel) => {
        const match = panel.dataset.l4Panel === itemKey;
        panel.hidden = !match;
        if (match) {
          // l4 opens one column right of its l3 (itemKey is "l2idx-l3idx").
          const col = Math.floor(parseInt(itemKey, 10) / 10);
          panel.style.setProperty('--l4-col', col + 2);
        }
      });
    };

    navItems.forEach((navItem) => {
      const idx = navItem.dataset.navItem;
      const dropdown = navRoot.querySelector(`[data-nav-dropdown="${idx}"]`);
      if (!dropdown) return;

      navItem.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        const mega = document.getElementById('rotim-mega-menu');
        if (mega && mega.classList.contains('is-open')) return;
        hideAll();
        dropdown.querySelectorAll('[data-l3-panel],[data-l4-panel]').forEach((p) => { p.hidden = true; });
        dropdown.querySelectorAll('[data-l2-item],[data-l3-item]').forEach((i) => { i.classList.remove('is-active'); });
        positionAndShow(dropdown, navItem);
      });

      navItem.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          if (!dropdown.matches(':hover')) hideAll();
        }, 100);
      });

      dropdown.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
      });

      dropdown.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(hideAll, 100);
      });

      dropdown.querySelectorAll('.nav-dropdown__col--l2 .nav-dropdown__item').forEach((l2Item) => {
        l2Item.addEventListener('mouseenter', () => {
          if (l2Item.dataset.l2Item !== undefined) {
            activateL2(dropdown, l2Item.dataset.l2Item);
          } else {
            dropdown.querySelectorAll('[data-l2-item]').forEach((i) => i.classList.remove('is-active'));
            dropdown.querySelectorAll('[data-l3-panel],[data-l4-panel]').forEach((p) => { p.hidden = true; });
            dropdown.querySelectorAll('[data-l3-item]').forEach((i) => i.classList.remove('is-active'));
          }
        });
      });

      dropdown.querySelectorAll('.nav-dropdown__col--l3 .nav-dropdown__item').forEach((l3Item) => {
        l3Item.addEventListener('mouseenter', () => {
          if (l3Item.dataset.l3Item !== undefined) {
            activateL3(dropdown, l3Item.dataset.l3Item);
          } else {
            dropdown.querySelectorAll('[data-l3-item]').forEach((i) => i.classList.remove('is-active'));
            dropdown.querySelectorAll('[data-l4-panel]').forEach((p) => { p.hidden = true; });
          }
        });
      });
    });

    window.addEventListener('resize', () => {
      const openDd = navRoot.querySelector('[data-nav-dropdown].is-open');
      if (!openDd) return;
      const top = getNavBottom();
      const trigger = openDd._triggerItem;
      const left = trigger
        ? Math.round(trigger.getBoundingClientRect().left) - 16
        : getPageLeft();
      document.documentElement.style.setProperty('--rotim-nav-bottom', `${top}px`);
      openDd.style.top = `${top}px`;
      openDd.style.left = `${left}px`;
    }, { passive: true });

    document.addEventListener('click', (event) => {
      if (!navRoot.contains(event.target)) hideAll();
    });

    if (navOverlay) navOverlay.addEventListener('click', hideAll);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hideAll();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeaderUspSwiper();
    toggleHeaderStickyClass();
    initDesktopMegaMenu();
    initNavDropdowns();
  });
  document.addEventListener('shopify:section:load', () => {
    initHeaderUspSwiper();
    initDesktopMegaMenu();
    initNavDropdowns();
  });
  window.addEventListener('scroll', toggleHeaderStickyClass, { passive: true });

  // The VAT switcher (Excl. / Incl. btw) is handled globally by
  // assets/vat-switcher.js, which persists the choice in localStorage, toggles
  // the `prices-incl-vat` class on <html>, and keeps every .vat-switcher-toggle
  // and .vat-switcher-title in sync.


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-blokken"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSwiper = () => {
      if (window.matchMedia('(min-width: 768px)').matches) {
        return
      }

      if (typeof window.Swiper === 'undefined') {
        return
      }

      document.querySelectorAll('[data-hero-blokken-slider]').forEach((slider) => {
        if (slider.swiper) {
          slider.swiper.destroy(true, true)
        }

        const section = slider.closest('[data-hero-blokken-section]')
        const delay = Number(section?.dataset?.autoplaySpeed) || 4000

        new window.Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          speed: 600,
          autoplay: {
            delay: delay,
            disableOnInteraction: false,
          },
        })
      })
    }

    initSwiper()
    window.addEventListener('load', initSwiper)

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector?.('[data-hero-blokken-slider]')) {
        initSwiper()
      }
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 768px)')

    const bindCategoryLinks = (root) => {
      if (root.dataset.homepageCategoriesBound) {
        return
      }

      root.addEventListener('click', (event) => {
        if (event.target.closest('.homepage-categories__nav')) {
          return
        }

        const category = event.target.closest('[data-homepage-category-link]')
        if (!category) {
          return
        }

        window.location.href = category.dataset.homepageCategoryLink
      })

      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return
        }

        const category = event.target.closest('[data-homepage-category-link]')
        if (!category) {
          return
        }

        event.preventDefault()
        window.location.href = category.dataset.homepageCategoryLink
      })

      root.dataset.homepageCategoriesBound = 'true'
    }

    const updateNavTop = (root) => {
      const imageWrap = root.querySelector('.homepage-categories__image-wrap')
      if (!imageWrap) return
      const imageRect = imageWrap.getBoundingClientRect()
      const rootRect = root.getBoundingClientRect()
      const navTop = (imageRect.top - rootRect.top) + imageRect.height / 2
      root.style.setProperty('--categories-nav-top', navTop + 'px')
    }

    const initHomepageCategories = () => {
      document.querySelectorAll('[data-homepage-categories-root]').forEach((root) => {
        const slider = root.querySelector('[data-homepage-categories-slider]')
        if (!slider) {
          return
        }

        bindCategoryLinks(root)

        if (!desktopQuery.matches) {
          if (slider.swiper) {
            slider.swiper.destroy(true, true)
          }
          return
        }

        if (typeof window.Swiper === 'undefined') {
          return
        }

        if (slider.swiper) {
          slider.swiper.destroy(true, true)
        }

        const prev = root.querySelector('[data-homepage-categories-prev]')
        const next = root.querySelector('[data-homepage-categories-next]')

        const options = {
          slidesPerView: 4,
          spaceBetween: 24,
          watchOverflow: true,
          breakpoints: {
            1200: {
              slidesPerView: 6,
            },
          },
        }

        if (prev && next) {
          options.navigation = {
            prevEl: prev,
            nextEl: next,
          }
        }

        new window.Swiper(slider, options)

        updateNavTop(root)
      })
    }

    window.addEventListener('resize', () => {
      document.querySelectorAll('[data-homepage-categories-root]').forEach(updateNavTop)
    })

    document.addEventListener('DOMContentLoaded', initHomepageCategories)
    desktopQuery.addEventListener('change', initHomepageCategories)

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target || typeof event.target.querySelector !== 'function') {
        return
      }
      if (event.target.querySelector('[data-homepage-categories-root]')) {
        initHomepageCategories()
      }
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHomepageReviews = () => {
      document.querySelectorAll('[data-homepage-reviews-root]').forEach((root) => {
        const slider = root.querySelector('[data-homepage-reviews-slider]')
        if (!slider || typeof window.Swiper === 'undefined') {
          return
        }

        if (slider.swiper) {
          slider.swiper.destroy(true, true)
        }

        const section = root.closest('.homepage-reviews')
        const prev = section?.querySelector('[data-homepage-reviews-prev]')
        const next = section?.querySelector('[data-homepage-reviews-next]')

        const options = {
          speed: 1500,
          spaceBetween: 0,
          slidesPerView: 1,
          breakpoints: {
            350: { slidesPerView: 1, spaceBetween: 15 },
            425: { slidesPerView: 1.25 },
            500: { slidesPerView: 1.5 },
            767: { slidesPerView: 2.25 },
            992: { slidesPerView: 3 },
          },
        }

        if (prev && next) {
          options.navigation = {
            prevEl: prev,
            nextEl: next,
          }
        }

        new window.Swiper(slider, options)
      })
    }

    document.addEventListener('DOMContentLoaded', initHomepageReviews)
    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target || typeof event.target.querySelector !== 'function') {
        return
      }
      if (event.target.querySelector('[data-homepage-reviews-root]')) {
        initHomepageReviews()
      }
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('[data-logo-slider]').forEach((sliderEl) => {
        if (typeof window.Swiper === 'undefined') return;
        if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);

        const section = sliderEl.closest('.logo-slider');
        if (!section) return;

        const prev = section.querySelector('[data-logo-slider-prev]');
        const next = section.querySelector('[data-logo-slider-next]');

        new window.Swiper(sliderEl, {
          slidesPerView: 3,
          spaceBetween: 12,
          slidesPerGroup: 2,
          loop: true,
          navigation: { prevEl: prev, nextEl: next },
          breakpoints: {
            640: { slidesPerView: 3, spaceBetween: 16, slidesPerGroup: 3 },
            768: { slidesPerView: 4, spaceBetween: 16, slidesPerGroup: 4 },
            1024: { slidesPerView: 5, spaceBetween: 16, slidesPerGroup: 5 },
          },
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector('[data-logo-slider]')) init();
    });

    // Popup open/close
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-logo-popup]');
      if (trigger) {
        const popup = document.getElementById('logo-popup-' + trigger.dataset.logoPopup);
        if (popup) {
          popup.showModal();
          document.body.style.overflow = 'hidden';
        }
        return;
      }

      const closeBtn = e.target.closest('.logo-popup__close');
      if (closeBtn) {
        closeBtn.closest('.logo-popup')?.close();
        return;
      }

      if (e.target.classList.contains('logo-popup')) {
        e.target.close();
      }
    });

    // <dialog> fires 'close' for every dismissal path (button, backdrop click
    // above, and Escape), so a single capture-phase listener restores scroll
    // regardless of how the popup was closed. 'close' doesn't bubble, but
    // capture-phase listeners on an ancestor still see it on the way down.
    document.addEventListener(
      'close',
      (e) => {
        if (e.target.classList && e.target.classList.contains('logo-popup')) {
          document.body.style.overflow = '';
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)')

    const init = () => {
      if (typeof window.Swiper === 'undefined') return

      document.querySelectorAll('[data-gerelateerde-producten]').forEach((slider) => {
        if (slider.swiper) slider.swiper.destroy(true, true)

        if (mobileQuery.matches) {
          new window.Swiper(slider, {
            slidesPerView: 1.3,
            spaceBetween: 16,
            watchOverflow: true,
          })
        }
      })

      document.querySelectorAll('[data-gerelateerde-collecties]').forEach((root) => {
        const slider = root.querySelector('[data-collecties-swiper]')
        if (!slider) return

        if (slider.swiper) slider.swiper.destroy(true, true)

        if (mobileQuery.matches) {
          new window.Swiper(slider, {
            slidesPerView: 1.3,
            spaceBetween: 24,
            watchOverflow: true,
            navigation: {
              prevEl: root.querySelector('[data-collecties-prev]'),
              nextEl: root.querySelector('[data-collecties-next]'),
              disabledClass: 'gerelateerde-collecties__arrow--disabled',
            },
          })
        }
      })
    }

    document.addEventListener('DOMContentLoaded', init)
    mobileQuery.addEventListener('change', init)

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector('[data-gerelateerde-producten], [data-gerelateerde-collecties]')) init()
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-hero').forEach((section) => {
    // Quantity stepper
    section.querySelectorAll('.product-hero__qty').forEach((qty) => {
      const input = qty.querySelector('input.product-hero__qty-input') || qty.querySelector('input');
      // Editable total in pieces: when custom.data02 is set, show qty x data02 in
      // place of the real quantity (which stays in the hidden input and is what
      // gets added to cart). Typing pieces converts back to packs, rounded up.
      const display = qty.querySelector('.product-hero__qty-display');
      const multiplier = parseFloat(qty.dataset.unitMultiplier);
      const updateDisplay = () => {
        if (!display || !multiplier) return;
        const val = parseInt(input.value, 10) || 1;
        const total = val * multiplier;
        display.value = Number.isInteger(total) ? total : parseFloat(total.toFixed(2));
      };
      if (display && multiplier) {
        const commitDisplay = () => {
          const pieces = parseFloat(display.value);
          if (!Number.isFinite(pieces) || pieces <= 0) {
            updateDisplay();
            return;
          }
          // Floor at 1 pack only. Don't clamp to input.min: Pify Order Limit
          // rewrites that attribute at runtime and enforces its own limits at
          // add-to-cart, same as the +/- buttons which never clamp up either.
          input.value = Math.max(1, Math.ceil(pieces / multiplier));
          updateDisplay();
          highlightVolumeTier();
          input.dispatchEvent(new Event('input', { bubbles: true }));
        };
        display.addEventListener('change', commitDisplay);
        display.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            display.blur();
          }
        });
      }
      qty.querySelector('[data-action="decrement"]')?.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        const min = parseInt(input.min || 1, 10);
        if (val > min) input.value = val - 1;
        updateDisplay();
        highlightVolumeTier();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      qty.querySelector('[data-action="increment"]')?.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        updateDisplay();
        highlightVolumeTier();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      if (input.classList.contains('product-hero__qty-input')) {
        input.addEventListener('input', () => { updateDisplay(); highlightVolumeTier(); });
        input.addEventListener('change', () => { updateDisplay(); highlightVolumeTier(); });
      }
      updateDisplay();
    });

    // Slider
    section.querySelectorAll('.product-hero__gallery--slider').forEach((slider) => {
      const track = slider.querySelector('.product-hero__slider-track');
      const slides = slider.querySelectorAll('.product-hero__slider-slide');
      const dots = slider.querySelectorAll('[data-dot]');
      let currentSlide = 0;

      const goTo = (index) => {
        currentSlide = index;
        track.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((d) => {
          d.classList.toggle('product-hero__slider-dot--active', parseInt(d.dataset.dot, 10) === index);
        });
      };

      slider.querySelector('.product-hero__slider-btn--prev')?.addEventListener('click', () => {
        goTo((currentSlide - 1 + slides.length) % slides.length);
      });
      slider.querySelector('.product-hero__slider-btn--next')?.addEventListener('click', () => {
        goTo((currentSlide + 1) % slides.length);
      });
      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(parseInt(dot.dataset.dot, 10)));
      });
    });

    // Lightbox
    const lightbox = section.querySelector('.product-hero__lightbox');
    if (!lightbox) return;

    const slides = lightbox.querySelectorAll('[data-slide]');
    let current = 0;

    const showSlide = (index) => {
      slides.forEach((s) => { s.hidden = true; });
      if (slides[index]) slides[index].hidden = false;
      current = index;
    };

    section.querySelectorAll('[data-gallery-index]').forEach((btn) => {
      btn.addEventListener('click', () => {
        showSlide(parseInt(btn.dataset.galleryIndex, 10) || 0);
        lightbox.showModal();
      });
    });

    lightbox.querySelector('.product-hero__lightbox-close')?.addEventListener('click', () => lightbox.close());
    lightbox.querySelector('.product-hero__lightbox-prev')?.addEventListener('click', () => {
      showSlide((current - 1 + slides.length) % slides.length);
    });
    lightbox.querySelector('.product-hero__lightbox-next')?.addEventListener('click', () => {
      showSlide((current + 1) % slides.length);
    });

    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) lightbox.close();
    });

    document.addEventListener('keydown', (e) => {
      if (!lightbox.open) return;
      if (e.key === 'Escape') lightbox.close();
      if (e.key === 'ArrowLeft') showSlide((current - 1 + slides.length) % slides.length);
      if (e.key === 'ArrowRight') showSlide((current + 1) % slides.length);
    });
  });

  // Clicking a tier must NOT add to cart (the Bundler default). Intercept in the capture
  // phase so we run before the Bundler's own (bubbling) listeners on the row/saving-text,
  // block them, and instead drive the quantity stepper — the highlight + prices follow.
  document.addEventListener('click', e => {
    const row = e.target.closest('.bndlr-volume-discount');
    if (!row) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    const tierQty = getTierQty(row);
    const input = document.querySelector('.product-hero__qty-input');
    if (input && tierQty != null) {
      input.value = tierQty;
      // Notify the stepper so the visual qty x data02 total follows tier clicks.
      input.dispatchEvent(new Event('input'));
      highlightVolumeTier();

    document.dispatchEvent(
      new Event('BSSVolumeDiscountChange')
    );
    }
  }, true);

  /* =====================
     QUANTITY → VOLUME TIER HIGHLIGHT
     ---------------------
     The Bundler widget and the .product-hero__qty-input stepper are independent.
     When the chosen quantity reaches a volume-discount tier we mirror the tier's
     :hover look by toggling `.active` on the single best (highest threshold ≤ qty)
     `.bndlr-volume-discount` row. Tier thresholds are read from the row's data
     attribute / input value the Bundler app injects (text is only a last resort).
     ===================== */
  const BNDLR_QTY_ATTRS = ['data-quantity', 'data-qty', 'data-bndlr-quantity', 'data-bundle-quantity'];

  function getTierQty(row) {
    const input = row.querySelector('input');
    const inputVal = input && parseInt(input.value, 10);
    if (Number.isFinite(inputVal) && inputVal > 1) return inputVal;
    for (const attr of BNDLR_QTY_ATTRS) {
      const src = (row.getAttribute(attr)) || (input && input.getAttribute(attr));
      const v = src && parseInt(src, 10);
      if (Number.isFinite(v) && v > 0) return v;
    }
    // Defensive last resort: leading integer in the tier's main text.
    const textEl = row.querySelector('.bndlr-volume-main-text');
    const m = textEl && textEl.textContent.match(/\d+/);
    const t = m && parseInt(m[0], 10);
    return Number.isFinite(t) && t > 0 ? t : null;
  }

  function highlightVolumeTier() {
    const input = document.querySelector('.product-hero__qty-input');
    const qty = (input && parseInt(input.value, 10)) || 1;
    const rows = document.querySelectorAll('.bndlr-volume-discount');
    let best = null;
    let bestQty = -Infinity;
    rows.forEach((row) => {
      const tierQty = getTierQty(row);
      if (tierQty != null && tierQty <= qty && tierQty > bestQty) {
        best = row;
        bestQty = tierQty;
      }
    });
    rows.forEach((row) => row.classList.toggle('active', row === best));
    applyTierPriceToHero();
  }

  /* =====================
     HERO PRICE ↔ ACTIVE TIER
     ---------------------
     When a volume tier is active we rewrite the hero price block to the line total
     (qty × discounted unit) and the per-unit line to the discounted unit price. Both
     elements render dual .vat-amount--excl / .vat-amount--incl spans (incl = net×1.21),
     so scaling either span's parsed amount by the same factor stays correct and the VAT
     toggle keeps working. Original strings are cached in data-hero-orig for restore.
     Reuses bndlrBaseNet/parseMoneyToCents/bndlrFmt + BNDLR_MONEY_RE/BNDLR_PCT_RE below.
     ===================== */
  function activeTierFactor() {
    const row = document.querySelector('.bndlr-volume-discount.active');
    if (!row) return null;
    const baseNet = bndlrBaseNet();
    if (!baseNet) return null;
    let tierNet = null;
    const priceEl = row.querySelector('.bndlr-volume-variant-price');
    // 1. net we injected for percentage tiers
    const inj = priceEl && priceEl.getAttribute('data-rotim-tier-net');
    if (inj) { const v = parseInt(inj, 10); if (Number.isFinite(v)) tierNet = v; }
    // 2. NET string the VAT sync stores on the price leaf/wrapper
    if (tierNet == null) {
      const leaf = row.querySelector('.bndlr-new-price') || priceEl;
      const netSrc = leaf && leaf.getAttribute('data-rotim-net');
      if (netSrc) { const c = parseMoneyToCents(netSrc); if (c != null) tierNet = c; }
    }
    // 3. fall back to the percentage in the saving text
    if (tierNet == null) {
      const savingEl = row.querySelector('.bndlr-volume-saving-text');
      const savingSrc = savingEl ? (savingEl.getAttribute('data-rotim-net') || savingEl.textContent) : '';
      const m = savingSrc.match(BNDLR_PCT_RE);
      if (m) {
        const pct = parseFloat(m[1].replace(',', '.'));
        if (Number.isFinite(pct)) tierNet = Math.round(baseNet * (1 - pct / 100));
      }
    }
    if (tierNet == null) return null;
    return tierNet / baseNet;
  }

  // Scale the money substring of every matching span by `mult` (null = restore original).
  // Only writes on change so mutating document.body doesn't feedback-loop bundlerObserver.
  // Struck (compare-at/old) spans are skipped unless `includeStruck` is set.
  function setHeroAmounts(selector, mult, includeStruck) {
    document.querySelectorAll(selector).forEach((span) => {
      if (!includeStruck && span.closest('s')) return; // leave the compare-at / old price untouched
      if (span.getAttribute('data-hero-orig') == null) span.setAttribute('data-hero-orig', span.textContent);
      const orig = span.getAttribute('data-hero-orig');
      let out;
      if (mult == null) {
        out = orig;
      } else {
        const m = orig.match(BNDLR_MONEY_RE);
        if (!m) { out = orig; }
        else {
          const cents = parseMoneyToCents(m[0]);
          if (cents == null) return;
          const s = bndlrFmt(Math.round(cents * mult));
          if (s == null) return; // formatter not ready; a later trigger retries
          out = orig.replace(BNDLR_MONEY_RE, s);
        }
      }
      if (span.textContent !== out) span.textContent = out;
    });
  }

  function applyTierPriceToHero() {
    // No active tier → factor 1 (no discount), but still scale by quantity below.
    const factor = activeTierFactor() || 1;
    const input = document.querySelector('.product-hero__qty-input');
    const qty = (input && parseInt(input.value, 10)) || 1;
    // BSS Product Options strips the `.vat-amount` class off one of the price spans
    // (its own price-sync pass) after the first render, without touching our
    // data-hero-orig attribute — fall back to that attribute so the span stays
    // tracked once the class is gone, instead of freezing at its last value.
    // Current price → line total (qty × discounted unit); skips the struck old price.
    setHeroAmounts('.product-hero__price .vat-amount, .product-hero__price [data-hero-orig]', qty * factor);
    // Old/compare-at price (struck) → qty × compare-at, no discount factor.
    setHeroAmounts('.product-hero__price s .vat-amount, .product-hero__price s [data-hero-orig]', qty, true);
    // Per-unit → discounted unit price only (unchanged when there is no tier).
    setHeroAmounts('.product-hero__per-unit .vat-amount, .product-hero__per-unit [data-hero-orig]', factor);
  }

  /* =====================
     BUNDLER VAT SYNC
     ---------------------
     The third-party Bundler widget renders its own prices (always NET, since
     Shopify stores prices excl. BTW) and ignores the header VAT switcher. This
     mirrors the switch onto the bundler: when incl. is active we show net x 1.21,
     otherwise we restore the original net string. State/event come from
     vat-switcher.js (window.RotimVat + the `rotim:vat-change` event); money is
     formatted via window.formatMoney from quote-cart.js so output matches the
     Liquid `| money` filter and the quote cart.
     ===================== */
  const BNDLR_PRICE_SELECTORS = '.bndlr-new-price, .bndlr-volume-variant-price, .bndlr-old-price';
  const BNDLR_SAVING_SELECTOR = '.bndlr-volume-saving-text';
  const BNDLR_MONEY_RE = /(?:€\s*)?\d[\d.,]*/;
  const BNDLR_PCT_RE = /(\d+(?:[.,]\d+)?)\s*%/;

  // Net unit price (cents) for the loaded product/variant, rendered by Liquid onto
  // the bundler target. Used to compute per-tier totals the app leaves empty.
  function bndlrBaseNet() {
    const t = document.getElementById('bundler-target-element');
    const v = t && parseInt(t.getAttribute('data-rotim-base-net'), 10);
    return Number.isFinite(v) ? v : null;
  }

  // Inverse of formatMoney for Dutch formatting (comma decimal, period thousands).
  function parseMoneyToCents(str) {
    const cleaned = String(str).replace(/[^\d.,-]/g, '');
    if (!cleaned) return null;
    const lastComma = cleaned.lastIndexOf(',');
    const lastDot = cleaned.lastIndexOf('.');
    const decSep = lastComma > lastDot ? ',' : (lastDot > lastComma ? '.' : null);
    let intPart, fracPart;
    if (decSep) {
      const idx = cleaned.lastIndexOf(decSep);
      intPart = cleaned.slice(0, idx).replace(/[.,]/g, '');
      fracPart = cleaned.slice(idx + 1).replace(/[.,]/g, '');
    } else {
      intPart = cleaned.replace(/[.,]/g, '');
      fracPart = '';
    }
    fracPart = (fracPart + '00').slice(0, 2);
    const cents = parseInt(intPart || '0', 10) * 100 + parseInt(fracPart, 10);
    return isNaN(cents) ? null : cents;
  }

  // Reuse Dawn's formatter from quote-cart.js. Returns null until it has loaded
  // (it is injected with `defer`), in which case the caller retries later.
  function bndlrFmt(cents) {
    return typeof window.formatMoney === 'function' ? window.formatMoney(cents) : null;
  }

  function bndlrInclCents(netCents) {
    const rate = (window.RotimVat && window.RotimVat.VAT_RATE) || 21;
    return Math.round(netCents * (100 + rate) / 100);
  }

  function bndlrVatOn() {
    return !!(window.RotimVat && typeof window.RotimVat.getState === 'function' && window.RotimVat.getState());
  }

  // custom.data02 (units per item): when set, bundler per-unit prices are shown
  // divided down to a single piece with a "/st" suffix. Returns null when unset.
  function bndlrUnitDivisor() {
    const mq = document.querySelector('.product-hero__qty[data-unit-multiplier]');
    const d = mq ? parseFloat(mq.dataset.unitMultiplier) : NaN;
    return Number.isFinite(d) && d > 0 ? d : null;
  }

  // Whole-textContent price element (data-rotim-rendered tracks our last write so
  // a fresh NET render by the bundler is detected and re-captured, never doubled).
  function syncBndlrPrice(el, includeVat) {
    // .bndlr-volume-variant-price is a WRAPPER around .bndlr-old-price/.bndlr-new-price.
    // Writing its textContent clobbers those child spans; the bundler then re-injects a
    // fresh price node, leaving our text + its node side by side (the "double price").
    // Skip any element that wraps a price leaf — the leaves sync themselves.
    if (el.querySelector('.bndlr-new-price, .bndlr-old-price')) return;
    const current = el.textContent.trim();
    if (el.getAttribute('data-rotim-rendered') !== current) {
      el.setAttribute('data-rotim-net', current);
    }
    const net = el.getAttribute('data-rotim-net');
    const divisor = bndlrUnitDivisor();
    let out;
    if (!includeVat && !divisor) {
      out = net; // fast path: no VAT, no per-piece division — leave net untouched
    } else {
      let cents = parseMoneyToCents(net);
      if (cents == null) return;
      if (divisor) cents = Math.ceil(cents / divisor);
      if (includeVat) cents = bndlrInclCents(cents);
      const s = bndlrFmt(cents);
      if (s == null) return; // formatter not ready; a later trigger retries
      out = divisor ? s + ' ' + (((window.volumePricingStrings || {}).perUnitSuffix) || '/st') : s;
    }
    if (out !== current) el.textContent = out;
    el.setAttribute('data-rotim-rendered', out);
  }

  // Saving text has a money amount embedded in words ("Bespaar € 5,00"); replace
  // only the money substring. Best-effort/fragile, so it is wrapped in try/catch.
  function syncBndlrSaving(el, includeVat) {
    const current = el.textContent;
    if (el.getAttribute('data-rotim-rendered') !== current) {
      el.setAttribute('data-rotim-net', current);
    }
    const orig = el.getAttribute('data-rotim-net');
    let out;
    // Percentage savings ("Bespaar 5%") have no money component — applying the
    // money regex would treat the bare digit as euros and corrupt the text.
    const isPercent = orig.indexOf('%') !== -1 && orig.indexOf('€') === -1;
    if (includeVat && !isPercent) {
      const m = orig.match(BNDLR_MONEY_RE);
      if (!m) return;
      const cents = parseMoneyToCents(m[0]);
      if (cents == null) return;
      const s = bndlrFmt(bndlrInclCents(cents));
      if (s == null) return;
      out = orig.replace(BNDLR_MONEY_RE, s);
    } else {
      out = orig;
    }
    if (out !== current) el.textContent = out;
    el.setAttribute('data-rotim-rendered', out);
  }

  // Percentage tiers leave .bndlr-volume-variant-price empty (the app only renders
  // a price for fixed-amount discounts). Compute the discounted price per piece
  // ourselves (net unit × (1 - pct/100)) and inject it as NET; the existing
  // leaf-sync then converts it for the VAT toggle. Idempotent via data-rotim-tier-net.
  // A row without a percentage (the first one, quantity 1) gets the plain base
  // price, so it no longer shows the app's zero.
  function injectBndlrTierPrices() {
    const baseNet = bndlrBaseNet();
    if (!baseNet) return;
    document.querySelectorAll('.bndlr-volume-discount').forEach((row) => {
      const priceEl = row.querySelector('.bndlr-volume-variant-price');
      if (!priceEl) return;
      // Rows the app prices itself wrap the amount in a .bndlr-new-price /
      // .bndlr-old-price leaf. Writing the wrapper's textContent clobbers those
      // spans and the app re-injects a fresh one (the double price), so write into
      // the .bndlr-new-price leaf instead and leave a lone old price alone.
      const leaf = priceEl.querySelector('.bndlr-new-price');
      if (!leaf && priceEl.querySelector('.bndlr-old-price')) return; // nothing to fill without clobbering
      const target = leaf || priceEl;
      const shownCents = parseMoneyToCents(target.getAttribute('data-rotim-net') || target.textContent);
      const alreadyOurs = target.getAttribute('data-rotim-tier-net') != null;
      // A leaf the app filled with a real amount stays its own. The € 0,00 it puts
      // in the 0% first row is the one we replace.
      if (leaf && shownCents && !alreadyOurs) return;
      const savingEl = row.querySelector('.bndlr-volume-saving-text');
      const savingSrc = savingEl ? (savingEl.getAttribute('data-rotim-net') || savingEl.textContent) : '';
      const m = savingSrc.match(BNDLR_PCT_RE);
      const pct = m ? parseFloat(m[1].replace(',', '.')) : 0;
      if (!Number.isFinite(pct)) return;
      // A row without a percentage is either the base row (quantity 1, no discount,
      // no saving text) or an amount-off tier the app prices itself. Only the base
      // row is ours to fill: an amount-off tier keeps what the app rendered,
      // otherwise we would price it as if it had no discount at all.
      if (!m && BNDLR_MONEY_RE.test(savingSrc)) return;
      // Base row / explicit 0% tier ("bespaar 0%"): the app leaves a zero in the
      // price cell, which is what showed as € 0,00 on the first row. Fill it with
      // the plain base price, but never overwrite a real price it rendered.
      if ((!m || pct === 0) && shownCents && !alreadyOurs) return;
      const netUnit = Math.round(baseNet * (1 - pct / 100));
      // Re-inject when the cell is empty AND when it parses back to zero: the app
      // rewriting a row to its 0 placeholder has to be picked up again.
      if (alreadyOurs && target.getAttribute('data-rotim-tier-net') === String(netUnit) && parseMoneyToCents(target.textContent)) return; // already injected
      const netStr = bndlrFmt(netUnit);
      if (netStr == null) return; // formatter not ready; retry covers it
      target.setAttribute('data-rotim-tier-net', String(netUnit));
      target.setAttribute('data-rotim-net', netStr);        // hand off to the existing VAT machinery
      target.setAttribute('data-rotim-rendered', netStr);
      // Only on change: an unconditional write mutates childList, which re-fires
      // bundlerObserver every frame.
      if (target.textContent !== netStr) target.textContent = netStr; // NET; syncBndlrPrice converts when Incl. BTW on
    });
  }

  // Visual-only: when custom.data02 is set, the tier label (data-quantity via CSS
  // ::before) should show qty x data02. Write the multiplied total to
  // data-rotim-display-quantity; pdp-app-overrides.css renders it instead of
  // data-quantity. The real data-quantity is left intact (tier thresholds + cart
  // rely on it). Deliberately NOT named data-display-quantity: Optis' custom
  // Bundler integration reads dataset.displayQuantity as the price quantity and
  // multiplied pieces by the pack price (25 x EUR 216,37 showed EUR 5.409,25).
  function applyDisplayQuantity() {
    const mq = document.querySelector('.product-hero__qty[data-unit-multiplier]');
    const mult = mq ? parseFloat(mq.dataset.unitMultiplier) : NaN;
    if (!mult) return;
    document.querySelectorAll('.bndlr-volume-discount[data-quantity]').forEach((row) => {
      const q = parseFloat(row.getAttribute('data-quantity'));
      if (!Number.isFinite(q)) return;
      const total = q * mult;
      const val = Number.isInteger(total) ? total : parseFloat(total.toFixed(2));
      if (row.getAttribute('data-rotim-display-quantity') !== String(val)) {
        row.setAttribute('data-rotim-display-quantity', String(val));
      }
      // Clean up the old attribute so Optis' fallback to data-quantity kicks in.
      if (row.hasAttribute('data-display-quantity')) row.removeAttribute('data-display-quantity');
    });
  }

  // Merchant-configured tier badge (e.g. "Aanbevolen"): custom.staffel_badge_positie
  // is the 1-based row index (1 = first tier), not the tier quantity, since Bundler
  // quantities shift per data02 multiplier and position is the stable reference.
  // Replaces the row's ::before label (see .rotim-has-badge in pdp-app-overrides.css)
  // with a real element so the badge can sit inline next to it without disturbing
  // the price/saving grid columns.
  function applyTierBadges() {
    const mq = document.querySelector('.product-hero__qty[data-tier-badge-text]');
    const badgeText = mq ? mq.getAttribute('data-tier-badge-text') : '';
    const badgePosition = mq ? mq.getAttribute('data-tier-badge-position') : '';
    const rows = document.querySelectorAll('.bndlr-volume-discount[data-quantity]');
    if (!rows.length) return;

    const section = mq ? mq.closest('.product-hero') : document.querySelector('.product-hero');
    let unitLabel = 'stuks';
    if (section) {
      const raw = getComputedStyle(section).getPropertyValue('--bndlr-unit-label').trim();
      if (raw) unitLabel = raw.replace(/^['"]|['"]$/g, '');
    }

    rows.forEach((row, i) => {
      const isMatch = !!badgeText && String(i + 1) === badgePosition;
      let wrap = row.querySelector('.rotim-tier-label');
      if (!isMatch) {
        if (wrap) wrap.remove();
        row.classList.remove('rotim-has-badge');
        return;
      }
      if (!wrap) {
        row.classList.add('rotim-has-badge');
        wrap = document.createElement('span');
        wrap.className = 'rotim-tier-label';
        wrap.innerHTML = '<span class="rotim-tier-label-qty"></span><span class="rotim-tier-badge"></span>';
        row.insertBefore(wrap, row.firstChild);
      }
      const displayQty = row.getAttribute('data-rotim-display-quantity') || row.getAttribute('data-quantity');
      const labelText = displayQty + ' ' + unitLabel;
      const qtySpan = wrap.querySelector('.rotim-tier-label-qty');
      const badgeSpan = wrap.querySelector('.rotim-tier-badge');
      if (qtySpan.textContent !== labelText) qtySpan.textContent = labelText;
      if (badgeSpan.textContent !== badgeText) badgeSpan.textContent = badgeText;
    });

    // Share one fixed label width across every row (--rotim-tier-col1, read by
    // .bndlr-volume-discount::before / .rotim-tier-label above) so space-between's
    // two gaps are identical row to row, keeping price's position constant
    // instead of shifting on whichever row carries the badge.
    const container = rows[0].closest('.bndlr-volume-discounts');
    if (container) {
      const badgedRow = Array.from(rows).find((row) => row.querySelector('.rotim-tier-label'));
      const wrap = badgedRow ? badgedRow.querySelector('.rotim-tier-label') : null;
      if (wrap) {
        const width = wrap.getBoundingClientRect().width;
        if (width > 0) container.style.setProperty('--rotim-tier-col1', width + 'px');
      } else {
        container.style.removeProperty('--rotim-tier-col1');
      }
    }
  }

  // Writing textContent mutates childList, which re-fires bundlerObserver; the
  // re-entrancy flag (reset on the next frame) breaks that feedback loop.
  let bndlrApplying = false;
  function applyVatToBundler() {
    if (bndlrApplying) return;
    bndlrApplying = true;
    try {
      injectBndlrTierPrices();
      applyDisplayQuantity();
      applyTierBadges();
      const includeVat = bndlrVatOn();
      document.querySelectorAll(BNDLR_PRICE_SELECTORS).forEach((el) => {
        try { syncBndlrPrice(el, includeVat); } catch (e) {}
      });
      document.querySelectorAll(BNDLR_SAVING_SELECTOR).forEach((el) => {
        try { syncBndlrSaving(el, includeVat); } catch (e) {}
      });
    } finally {
      requestAnimationFrame(() => { bndlrApplying = false; });
    }
  }

  document.addEventListener('rotim:vat-change', applyVatToBundler);

  function initBundlerMeerBekijken() {
    const container = document.querySelector('.bndlr-volume-discounts');
    if (!container) return;
    if (container.querySelector('.bndlr-meer-bekijken')) return;

    const rows = container.querySelectorAll('.bndlr-volume-discount');
    if (rows.length <= 2) return;

    container.classList.add('bndlr-truncated');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bndlr-meer-bekijken';
    var bndlrShowMore = ((window.volumePricingStrings || {}).showMore) || 'meer bekijken';
    var bndlrShowLess = ((window.volumePricingStrings || {}).showLess) || 'minder bekijken';
    btn.innerHTML = '<span>' + bndlrShowMore + '</span><svg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';
    container.appendChild(btn);

    // Toggle expand/collapse. The observer stays connected: initBundlerMeerBekijken
    // early-returns once the button exists (so it won't re-add the button or
    // re-truncate), and keeping the observer alive preserves VAT sync on the rows
    // that become visible when expanded.
    let expanded = false;
    btn.addEventListener('click', () => {
      expanded = !expanded;
      container.classList.toggle('bndlr-truncated', !expanded);
      btn.classList.toggle('bndlr-expanded', expanded);
      btn.querySelector('span').textContent = expanded ? bndlrShowLess : bndlrShowMore;
    });
  }

  const bundlerTarget = document.getElementById('bundler-target-element');
  const bundlerObserver = new MutationObserver(() => {
    initBundlerMeerBekijken();
    applyVatToBundler();
    highlightVolumeTier();
  });
  if (bundlerTarget) {
    initBundlerMeerBekijken();
    applyVatToBundler();
    highlightVolumeTier();
    bundlerObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', () => {
      initBundlerMeerBekijken();
      applyVatToBundler();
      highlightVolumeTier();
    }, { once: true });

    // Bridge the gap until the bundler has injected its prices and quote-cart.js
    // (deferred) has exposed window.formatMoney. Stops once the formatter exists.
    let bndlrTries = 0;
    const bndlrRetry = setInterval(() => {
      applyVatToBundler();
      highlightVolumeTier();
      if (++bndlrTries >= 20 || typeof window.formatMoney === 'function') {
        clearInterval(bndlrRetry);
      }
    }, 100);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tabBar = document.getElementById('product-tab-bar');
    if (!tabBar) return;

    const nav = tabBar.querySelector('.product-tab-bar__nav');
    if (!nav) return;

    const build = () => {
      const anchors = [...document.querySelectorAll('[data-section-anchor]')];
      if (!anchors.length) return;

      nav.innerHTML = '';
      anchors.forEach((anchor) => {
        const a = document.createElement('a');
        a.href = '#' + anchor.id;
        a.className = 'product-tab-bar__tab';
        a.dataset.tabAnchor = anchor.id;
        a.textContent = anchor.dataset.sectionAnchor;
        nav.appendChild(a);
      });

      const tabs = [...nav.querySelectorAll('[data-tab-anchor]')];

      const setActive = (id) => tabs.forEach((t) =>
        t.classList.toggle('product-tab-bar__tab--active', t.dataset.tabAnchor === id)
      );

      anchors.forEach((anchor) => {
        new IntersectionObserver(
          ([entry]) => { if (entry.isIntersecting) setActive(anchor.id); },
          { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
        ).observe(anchor);
      });

      tabs.forEach((tab) => tab.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById(tab.dataset.tabAnchor);
        if (!target) return;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - tabBar.offsetHeight - 120,
          behavior: 'smooth'
        });
      }));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', build);
    } else {
      build();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)')

    const initPanel = (panel, tcSection) => {
      const slider = panel.querySelector('[data-tc-slider]')
      if (!slider || typeof window.Swiper === 'undefined') return

      if (slider.swiper) slider.swiper.destroy(true, true)

      const desktopSlider = panel.dataset.tcDesktopSlider === 'true'

      if (mobileQuery.matches) {
        const refEl = tcSection.querySelector('.tc__heading-area') ?? tcSection.querySelector('.page-width')
        const slidesOffsetBefore = refEl
          ? Math.max(0, Math.round(refEl.getBoundingClientRect().left))
          : 24

        new window.Swiper(slider, {
          slidesPerView: 1.25,
          spaceBetween: 16,
          slidesOffsetBefore,
          watchOverflow: true,
        })
        return
      }

      if (!desktopSlider) return

      const prev = panel.querySelector('[data-tc-prev]')
      const next = panel.querySelector('[data-tc-next]')

      const options = {
        slidesPerView: 4,
        spaceBetween: 22,
        watchOverflow: true,
      }

      if (prev && next) {
        options.navigation = { prevEl: prev, nextEl: next }
      }

      new window.Swiper(slider, options)
    }

    const setupTabbedCollection = (tcSection) => {
      const tablist = tcSection.querySelector('[data-tc-tabs]')
      const ctaLink = tcSection.querySelector('[data-tc-cta-link]')
      const ctaFixed = ctaLink?.dataset.tcCtaFixed === 'true'

      const firstPanel = tcSection.querySelector('[data-tc-panel="1"]')
      if (firstPanel) initPanel(firstPanel, tcSection)

      if (!tablist) return

      tablist.querySelectorAll('[data-tc-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const idx = tab.dataset.tcTab

          tablist.querySelectorAll('[data-tc-tab]').forEach((t) => {
            t.setAttribute('aria-selected', t.dataset.tcTab === idx ? 'true' : 'false')
          })

          tcSection.querySelectorAll('[data-tc-panel]').forEach((panel) => {
            if (panel.dataset.tcPanel === idx) {
              panel.removeAttribute('hidden')
              requestAnimationFrame(() => initPanel(panel, tcSection))
            } else {
              const s = panel.querySelector('[data-tc-slider]')
              if (s?.swiper) s.swiper.destroy(true, true)
              panel.setAttribute('hidden', '')
            }
          })

          if (ctaLink && !ctaFixed) {
            const activePanel = tcSection.querySelector(`[data-tc-panel="${idx}"]`)
            const colUrl = activePanel?.dataset.tcColUrl
            if (colUrl) ctaLink.href = colUrl
          }
        })
      })
    }

    const init = () => {
      document.querySelectorAll('[data-tc-section]').forEach(setupTabbedCollection)
    }

    document.addEventListener('DOMContentLoaded', init)

    mobileQuery.addEventListener('change', () => {
      document.querySelectorAll('[data-tc-section]').forEach((tcSection) => {
        tcSection.querySelectorAll('[data-tc-panel]:not([hidden])').forEach((panel) => {
          initPanel(panel, tcSection)
        })
      })
    })

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target?.querySelector('[data-tc-section]') ?? (event.target?.matches('[data-tc-section]') ? event.target : null)
      if (!section) return
      setupTabbedCollection(section)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-blocks"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)')

    const init = () => {
      document.querySelectorAll('[data-usp-section]').forEach((section) => {
        const slider = section.querySelector('[data-usp-slider]')
        if (!slider || typeof window.Swiper === 'undefined') return

        if (slider.swiper) slider.swiper.destroy(true, true)

        if (!mobileQuery.matches) return

        // .usp-blocks__ref is a child of .page-width, so its
        // getBoundingClientRect().left equals the page content left edge —
        // the same technique used in featured-collection with .collection__title.
        const refEl = section.querySelector('.usp-blocks__ref')
        const slidesOffsetBefore = refEl
          ? Math.max(0, Math.round(refEl.getBoundingClientRect().left))
          : 24

        new window.Swiper(slider, {
          slidesPerView: 1.25,
          spaceBetween: 16,
          slidesOffsetBefore,
          watchOverflow: true,
        })
      })
    }

    document.addEventListener('DOMContentLoaded', init)
    mobileQuery.addEventListener('change', init)

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.querySelector('[data-usp-section]') || event.target?.dataset?.uspSection !== undefined) {
        init()
      }
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
